import React from 'react'
import CataloguesPage from './Catalogues'

const Catalogues = () => (
  <CataloguesPage/>
)

export default Catalogues
